// ============= User Relay Hub Events =============

/**
 * Enumerates user/workspace membership and workspace lifecycle events
 * raised on the User relay SignalR hub.
 */
export enum UserRelayHubEvents {
  WORKSPACE_ADDED = 'WORKSPACE_ADDED',
  USER_ADDED_TO_WORKSPACE = 'USER_ADDED_TO_WORKSPACE',
  USER_DELETED_FROM_WORKSPACE = 'USER_DELETED_FROM_WORKSPACE',
  USER_PROMOTED_TO_OWNER_IN_WORKSPACE = 'USER_PROMOTED_TO_OWNER_IN_WORKSPACE',
  USER_DEMOTED_FROM_OWNER_IN_WORKSPACE = 'USER_DEMOTED_FROM_OWNER_IN_WORKSPACE',
  USER_REACTIVATED_IN_WORKSPACE = 'USER_REACTIVATED_IN_WORKSPACE',
  WORKSPACE_UPDATED = 'WORKSPACE_UPDATED',

  /** User online. Fired when a user connects (e.g. after joining user group). Used to keep isOnline state correct. */
  USER_ONLINE = 'USER_ONLINE',

  /** User offline. Fired when a user disconnects. Used to keep isOnline state correct. */
  USER_OFFLINE = 'USER_OFFLINE',

  /** Message received from another user (e.g. presence ARE_YOU_THERE / I_AM_HERE). */
  RECEIVE_MESSAGE = 'ReceiveMessage',
}

/**
 * Presence discovery message types sent via UserRelayHub SendMessageToUserAsync.
 * New joiner sends ARE_YOU_THERE to each workspace member; online members reply I_AM_HERE.
 */
export const UserRelayHubPresenceMessageType = {
  ARE_YOU_THERE: 'ARE_YOU_THERE',
  I_AM_HERE: 'I_AM_HERE',
} as const;
